var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "view-action-form",
      attrs: { hide: _vm.pageLoading },
    },
    [
      _vm.actionLogger && _vm.project
        ? _c(
            "div",
            [
              _c("cms-heading", { attrs: { title: _vm.pageTitle } }),
              _c(
                "cms-form-panel",
                {
                  attrs: {
                    "submit-button": "Opslaan",
                    "cancel-button": true,
                    submitting: _vm.submitting,
                  },
                  on: { submit: _vm.submit },
                },
                [
                  _c("cms-form-input", {
                    attrs: {
                      title: "Logger",
                      name: "logger",
                      disabled: "true",
                    },
                    model: {
                      value: _vm.actionLogger.serialNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.actionLogger,
                          "serialNumber",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "actionLogger.serialNumber",
                    },
                  }),
                  _c("cms-form-input", {
                    attrs: {
                      title: "Projectcode",
                      name: "project",
                      disabled: "true",
                    },
                    model: {
                      value: _vm.project.code,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.project,
                          "code",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "project.code",
                    },
                  }),
                  _c("cms-form-input", {
                    attrs: {
                      title: "Projectleider",
                      name: "projectLeader",
                      disabled: "true",
                    },
                    model: {
                      value: _vm.project.projectManager,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.project,
                          "projectManager",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "project.projectManager",
                    },
                  }),
                  _vm.userIsAdmin
                    ? _c("cms-form-dropdown", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          title: "Status",
                          name: "state",
                          options: _vm.stateOptions,
                          "data-vv-as": "Status",
                          error: _vm.error("state"),
                          "data-vv-name": "state",
                        },
                        model: {
                          value: _vm.pendingAction.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.pendingAction, "state", $$v)
                          },
                          expression: "pendingAction.state",
                        },
                      })
                    : _vm._e(),
                  _c("cms-form-row", { attrs: { title: "Meetpunt" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.pendingAction.measuringPoint,
                          expression: "pendingAction.measuringPoint",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "input-normal",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        name: "measuringPoint",
                      },
                      domProps: { value: _vm.pendingAction.measuringPoint },
                      on: {
                        blur: [
                          _vm.onMeasuringPointBlur,
                          function ($event) {
                            return _vm.$forceUpdate()
                          },
                        ],
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.pendingAction,
                            "measuringPoint",
                            $event.target.value.trim()
                          )
                        },
                      },
                    }),
                  ]),
                  _c("cms-form-row", { attrs: { title: "Locatie" } }, [
                    _c(
                      "div",
                      { staticClass: "places-holder" },
                      [
                        _c("gmap-autocomplete", {
                          ref: "autocompleteInput",
                          staticClass: "input-normal",
                          attrs: {
                            value: _vm.pendingAction.locationTitle,
                            "select-first-on-enter": true,
                            disabled: _vm.locationAutoSelected,
                          },
                          on: {
                            place_changed: _vm.setPlace,
                            blur: _vm.onLocationBlur,
                          },
                        }),
                        _vm.locationAutoSelected
                          ? _c(
                              "cms-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.switchLocationManual()
                                  },
                                },
                              },
                              [_vm._v("Wijzigen")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "cms-form-input",
                    {
                      staticClass: "has-edit-button",
                      attrs: {
                        title: "Meetfrequentie",
                        name: "measuringFrequency",
                        disabled: _vm.measuringFrequencyAutoSelected,
                      },
                      model: {
                        value: _vm.pendingAction.measuringFrequency,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.pendingAction,
                            "measuringFrequency",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "pendingAction.measuringFrequency",
                      },
                    },
                    [
                      _vm.measuringFrequencyAutoSelected
                        ? _c(
                            "cms-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.switchMeasuringFrequencyManual()
                                },
                              },
                            },
                            [_vm._v("Wijzigen")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "cms-form-input",
                    {
                      staticClass: "has-edit-button",
                      attrs: {
                        title: "Zendfrequentie",
                        name: "transmissionFrequency",
                        disabled: _vm.transmissionFrequencyAutoSelected,
                      },
                      model: {
                        value: _vm.pendingAction.transmissionFrequency,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.pendingAction,
                            "transmissionFrequency",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "pendingAction.transmissionFrequency",
                      },
                    },
                    [
                      _vm.transmissionFrequencyAutoSelected
                        ? _c(
                            "cms-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.switchTransmissionFrequencyManual()
                                },
                              },
                            },
                            [_vm._v("Wijzigen")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("cms-form-checkbox", {
                    attrs: {
                      title: "Categorieën kantoor",
                      name: "categories",
                      options: _vm.categoryOptions,
                    },
                    model: {
                      value: _vm.pendingAction.categories,
                      callback: function ($$v) {
                        _vm.$set(_vm.pendingAction, "categories", $$v)
                      },
                      expression: "pendingAction.categories",
                    },
                  }),
                  _c("cms-form-textarea", {
                    attrs: {
                      title: "Opmerkingen kantoor",
                      name: "commentsOffice",
                    },
                    model: {
                      value: _vm.pendingAction.commentsOffice,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pendingAction,
                          "commentsOffice",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pendingAction.commentsOffice",
                    },
                  }),
                  _c("cms-form-checkbox", {
                    attrs: {
                      title: "Categorieën veld",
                      name: "categoriesField",
                      options: _vm.categoryFieldOptions,
                    },
                    model: {
                      value: _vm.pendingAction.categoriesField,
                      callback: function ($$v) {
                        _vm.$set(_vm.pendingAction, "categoriesField", $$v)
                      },
                      expression: "pendingAction.categoriesField",
                    },
                  }),
                  _c("cms-form-textarea", {
                    attrs: { title: "Opmerkingen veld", name: "commentsField" },
                    model: {
                      value: _vm.pendingAction.commentsField,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pendingAction,
                          "commentsField",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pendingAction.commentsField",
                    },
                  }),
                  _c("cms-form-date-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      title: "Datum van probleem",
                      name: "issueDate",
                      input: "true",
                      options: { disableMobile: true },
                      "data-vv-as": "Datum van probleem",
                      error: _vm.error("issueDate"),
                      "data-vv-name": "issueDate",
                    },
                    model: {
                      value: _vm.pendingAction.issueDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.pendingAction, "issueDate", $$v)
                      },
                      expression: "pendingAction.issueDate",
                    },
                  }),
                  !_vm.pendingAction.issueDate
                    ? _c(
                        "cms-form-row",
                        { attrs: { title: "Deadline van probleem" } },
                        [_vm._v("Kies eerst datum van probleem")]
                      )
                    : _c("cms-form-date-picker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          title: "Deadline van probleem",
                          name: "deadlineDate",
                          input: "true",
                          options: { disableMobile: true },
                          "data-vv-as": "Deadline van probleem",
                          error: _vm.error("deadlineDate"),
                          "data-vv-name": "deadlineDate",
                        },
                        model: {
                          value: _vm.deadlineDate,
                          callback: function ($$v) {
                            _vm.deadlineDate = $$v
                          },
                          expression: "deadlineDate",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }